var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.44 64.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.79 24.94a9.36 9.36 0 1 1 7.35 3.56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.14,
    cy: 19.14,
    r: 17.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.58 34.59 4.39 6.61"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.67,
    height: 24.82,
    x: 35.8,
    y: 38.99,
    rx: 3.84,
    transform: "rotate(-31.42 39.639 51.394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.82 47.59-5.55 3.45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ccfcef5008d6514b77f2d955e29526ed.svg";
export { ForwardRef as ReactComponent };